'use strict';

var getScrollY = require('../utils/getScrollY'),
    { isMobile } = require('../utils/Browser'),
    { throttle } = require('underscore');

var currentScrollY,
    previousScrollY,
    maxScrollY,
    windowHeight,
    SENSITIVITY = 10;

function updateCurrentScrollY() {
  var scrollY = getScrollY();
  if (Math.abs(scrollY - currentScrollY) < SENSITIVITY) {
    return;
  }

  previousScrollY = currentScrollY;
  currentScrollY = scrollY;
}

var updateMetrics = throttle(function () {
  windowHeight = window.innerHeight;
  maxScrollY = document.body.scrollHeight - windowHeight;
}, 1000);

/**
 * Define `getScrollState(scrollY) -> state` and `scrollStateDidUpdate()` to react to scroll.
 */
var ScrollStateMixin = {
  getInitialState() {
    updateCurrentScrollY();
    return this.getScrollState(currentScrollY, currentScrollY, maxScrollY);
  },

  componentDidMount() {
    if (!isMobile()) {
      window.addEventListener('scroll', this.updateScrollState);
    }
  },

  componentWillUnmount() {
    if (!isMobile()) {
      window.removeEventListener('scroll', this.updateScrollState);
    }
  },

  updateScrollState() {
    if (!this.isMounted() || isMobile()) {
      return;
    }

    updateCurrentScrollY();
    updateMetrics();

    var scrollState = this.getScrollState(currentScrollY, previousScrollY, maxScrollY, windowHeight),
        needsSetState = false;

    for (var key in scrollState) {
      if (!scrollState.hasOwnProperty(key)) {
        continue;
      }

      if (scrollState[key] !== this.state[key]) {
        needsSetState = true;
        break;
      }
    }

    if (!needsSetState) {
      return;
    }

    this.setState(scrollState, this.scrollStateDidUpdate);
  },

  hasScrolledPastOffset(offset) {
    var scrollY = Math.min(currentScrollY, maxScrollY);

    if (offset) {
      return scrollY > offset;
    } else {
      return false;
    }
  },

  hasScrolledToOffset(offset) {
    var scrollY = Math.min(currentScrollY, maxScrollY);

    if (offset) {
      return scrollY > (offset - windowHeight);
    } else {
      return false;
    }
  }
};

module.exports = ScrollStateMixin;


/** WEBPACK FOOTER **
 ** ./mixins/ScrollStateMixin.js
 **/